import { render, staticRenderFns } from "./ServiceDocumentItem.vue?vue&type=template&id=56efcf38&"
import script from "./ServiceDocumentItem.vue?vue&type=script&lang=js&"
export * from "./ServiceDocumentItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports